import config from "@Config/index";
import axios from "axios";

const fetchFeaturedAccomodations = async ({
  isCountry,
  region,
  isWhitelabel,
  userCurrency,
}: any) => {
  const params: any = {
    only: "id,status,name,canonical_name,location,pricing,tags,virtual_views,videos",
    methods:
      "children_count,reviews_rating,reviews_count,region_parent_country,region_parent_city,region_parent_city_canonical,top_meta_distances",
    limit: "10",
    sort_key: "recent_bookings_count",
    sort_order: "desc",
    available: true,
    ...(isWhitelabel && { exclude_whitelabel_inventories: false }),
  };

  if (isCountry) {
    params.location_country_long_name = region?.location?.country?.long_name;
  } else {
    params.location_state_long_name = region?.location?.state?.long_name;
  }

  if (userCurrency) params.user_currency = userCurrency;

  const { data } = await axios(`${config.API_URL}/api/v1/inventories`, {
    params: { ...params, use_java_api: true },
    headers: { "X-Use-Java-Api": "true" },
  });

  return data?.data?.result ? data.data.result : [];
};

export default fetchFeaturedAccomodations;
